import { Phone, MapPin, Mail, Clock } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2, EMAIL, DIRECTIONS_URL, MAP_EMBED_URL } from "../../lib/site";
import { Reveal, SectionTag } from "./Reveal";

const HOURS = [
  { day: "Monday–Friday", time: "9:00 AM – 4:00 PM" },
  { day: "Saturday", time: "9:00 AM – 12:00 PM" },
  { day: "Sunday", time: "Closed" },
];

export const LocationSection = () => (
  <section id="contact" className="bg-zinc-100 py-20 sm:py-28" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag number="07" label="Location" />
        <h2 className="font-heading text-4xl sm:text-5xl text-zinc-950 tracking-tight">FIND THE YARD</h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-2 gap-4">
        <Reveal className="bg-white border border-zinc-200 p-8 sm:p-10">
          <h3 className="font-heading text-2xl text-zinc-950 tracking-wide">SCRAPMAN'S METAL RECYCLING LLC</h3>

          <div className="mt-8 space-y-5">
            <div className="flex gap-4">
              <MapPin className="h-5 w-5 text-red-700 shrink-0 mt-0.5" />
              <p className="text-zinc-700 font-medium">{ADDRESS_LINE1}<br />{ADDRESS_LINE2}</p>
            </div>
            <div className="flex gap-4">
              <Phone className="h-5 w-5 text-red-700 shrink-0 mt-0.5" />
              <a href={PHONE_TEL} className="font-heading text-2xl text-zinc-950 hover:text-red-700 transition-colors" data-testid="contact-phone-link">
                {PHONE_DISPLAY}
              </a>
            </div>
            <div className="flex gap-4">
              <Mail className="h-5 w-5 text-red-700 shrink-0 mt-0.5" />
              <a href={`mailto:${EMAIL}`} className="text-zinc-700 font-medium hover:text-red-700 transition-colors" data-testid="contact-email-link">
                {EMAIL}
              </a>
            </div>
            <div className="flex gap-4">
              <Clock className="h-5 w-5 text-red-700 shrink-0 mt-0.5" />
              <div className="w-full max-w-xs">
                {HOURS.map((h) => (
                  <div key={h.day} className="flex justify-between border-b border-zinc-100 py-1.5 text-sm">
                    <span className="font-semibold text-zinc-800">{h.day}</span>
                    <span className={h.time === "Closed" ? "text-red-700 font-semibold" : "text-zinc-600"}>{h.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-zinc-950 text-white px-6 py-3.5 font-heading tracking-wider hover:bg-zinc-800 transition-colors"
              data-testid="contact-directions-cta"
            >
              <MapPin className="h-4 w-4" />
              GET DIRECTIONS
            </a>
            <a
              href={PHONE_TEL}
              className="inline-flex items-center justify-center gap-2 bg-red-700 text-white px-6 py-3.5 font-heading tracking-wider hover:bg-red-800 transition-colors"
              data-testid="contact-call-cta"
            >
              <Phone className="h-4 w-4" />
              CALL SCRAPMAN'S
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="border border-zinc-200 min-h-[380px] bg-white">
          <iframe
            title="Scrapman's Metal Recycling — 253 S Franklin St, Ashley, OH 43003"
            src={MAP_EMBED_URL}
            className="w-full h-full min-h-[380px] grayscale-[35%]"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="location-map"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
